namespace $ {

	export class $shm_ba_report extends $mol_object2 {

		record() {
			return null as $shm_ba_pb_file_record | null
		}

		dashboard_id() {
			return ''
		}

		id() {
			return this.record()?.id ?? 'default'
		}

		title() {
			const record = this.record()
			if( !record ) return 'Сводный отчет'

			return String(
				record.title
				?? record.name
				?? record.label
				?? record.id
			)
		}

		js_code( next?: string ) {
			const record = this.record()
			if( !record ) return ''
			if( next !== undefined ) {
				this.$.$shm_ba_pb.update_record( 'dashboard_reports', record.id, { js_code: next } )
				return next
			}
			return String( record.js_code ?? '' )
		}

		opencode_session_id( next?: string ) {
			return ''
		}

		static default( dashboard_id: string ) {
			const obj = new this.$.$shm_ba_report()
			obj.dashboard_id = ()=> dashboard_id
			return obj
		}

		static from_record( dashboard_id: string, record: $shm_ba_pb_file_record ) {
			const obj = new this.$.$shm_ba_report()
			obj.record = ()=> record
			obj.dashboard_id = ()=> dashboard_id
			return obj
		}

		@ $mol_mem_key
		static records( dashboard_id: string ) {
			if( !dashboard_id || dashboard_id === 'default' ) return [] as readonly $shm_ba_pb_file_record[]
			return this.$.$shm_ba_pb.records_realtime(
				`dashboard_reports\ndashboard = "${ this.$.$shm_ba_pb.filter_text( dashboard_id ) }"\nsort,title`,
			)
		}

		@ $mol_mem_key
		static item( dashboard_report: string ) {
			const [ dashboard_id, report_id ] = dashboard_report.split( '\n' )
			if( report_id === 'default' ) return this.default( dashboard_id )

			const obj = new this.$.$shm_ba_report()
			const record = this.records( dashboard_id ).find( record => record.id === report_id ) ?? null
			obj.record = ()=> record
			obj.dashboard_id = ()=> dashboard_id
			return obj
		}

		static list( dashboard_id: string ) {
			return [
				this.default( dashboard_id ),
				... this.records( dashboard_id ).map( record => this.item( `${ dashboard_id }\n${ record.id }` ) ),
			]
		}

		static sort_next( dashboard_id: string ) {
			return this.records( dashboard_id ).reduce(
				( max, report )=> Math.max( max, Number( report.sort ?? 0 ) ),
				0,
			) + 1
		}

		static make_report( dashboard_id: string, title?: string, js_code = '' ) {
			const record = this.$.$shm_ba_pb.create_record( 'dashboard_reports', {
				dashboard: dashboard_id,
				title: title || `Отчет ${ this.records( dashboard_id ).length + 2 }`,
				sort: this.sort_next( dashboard_id ),
				js_code,
			} )
			return this.from_record( dashboard_id, record )
		}

		rename( title: string ) {
			const record = this.record()
			if( !record ) throw new Error( 'Cannot rename built-in report' )
			this.$.$shm_ba_pb.update_record( 'dashboard_reports', record.id, { title } )
			return title
		}

		delete() {
			const record = this.record()
			if( !record ) throw new Error( 'Cannot delete built-in report' )
			this.$.$shm_ba_pb.delete_record( 'dashboard_reports', record.id )
			return true
		}

		delete_later() {
			const record = this.record()
			if( !record ) throw new Error( 'Cannot delete built-in report' )
			this.$.$mol_wire_async( this.$.$shm_ba_pb ).delete_record(
				'dashboard_reports',
				record.id,
			).catch( error => this.$.$mol_fail_log( error ) )
			return true
		}

	}

}
